module.exports = __webpack_public_path__ + "img/send-bill-and-receipt-2-th.6f4bfbe.png";